import { useEffect, useState } from "react";
import { App, Button, Dropdown, Empty, Input, Modal, Tooltip } from "antd";
import { FontSizeOutlined, FullscreenExitOutlined, FullscreenOutlined, SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

interface NavigationEntry { path: string; name: string; routes?: NavigationEntry[] }

export function HeaderTools({ routes, fontSize, onFontSize }: {
  routes: NavigationEntry[];
  fontSize: number;
  onFontSize: (size: number) => void;
}) {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [fullscreen, setFullscreen] = useState(!!document.fullscreenElement);
  useEffect(() => {
    const update = () => setFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", update);
    return () => document.removeEventListener("fullscreenchange", update);
  }, []);
  const pages = routes.flatMap((route) => route.routes
    ? route.routes.map((child) => ({ ...child, group: route.name }))
    : [{ ...route, group: "" }]);
  const results = pages.filter((page) => `${page.group}${page.name}`.includes(query.trim()));
  const toggleFullscreen = async () => {
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      else await document.documentElement.requestFullscreen();
    } catch { message.warning("当前浏览器暂不支持全屏，请使用浏览器的全屏功能"); }
  };
  return <>
    <Tooltip title="搜索页面"><Button type="text" className="header-tool" aria-label="搜索页面" icon={<SearchOutlined />} onClick={() => { setQuery(""); setSearchOpen(true); }} /></Tooltip>
    <Tooltip title={fullscreen ? "退出全屏" : "全屏"}><Button type="text" className="header-tool header-fullscreen" aria-label={fullscreen ? "退出全屏" : "全屏"} icon={fullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />} onClick={() => void toggleFullscreen()} /></Tooltip>
    <Dropdown trigger={["click"]} menu={{ selectable: true, selectedKeys: [String(fontSize)], items: [{ key: "14", label: "标准字号" }, { key: "16", label: "大字号" }], onClick: ({ key }) => onFontSize(Number(key)) }}>
      <Button type="text" className="header-tool" aria-label="调整字号" title="调整字号" icon={<FontSizeOutlined />} />
    </Dropdown>
    <Modal title="搜索页面" open={searchOpen} onCancel={() => setSearchOpen(false)} footer={null} afterOpenChange={(open) => { if (open) document.getElementById("agent-page-search")?.focus(); }}>
      <Input id="agent-page-search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="输入页面名称" prefix={<SearchOutlined />} allowClear />
      <div className="header-search-results">
        {results.length ? results.map((page) => <button key={page.path} type="button" onClick={() => { navigate(page.path); setSearchOpen(false); }}><span>{page.name}</span><small>{page.group}</small></button>) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="未找到相关页面" />}
      </div>
    </Modal>
  </>;
}
